import React from 'react';
import SharedSearchInput from '../../../../components/shared/SharedSearchInput/SharedSearchInput';

/**
 * ListViewHeader - Top bar of the ListView with search and main actions.
 * 
 * @param {Object} props
 * @param {string} props.searchTerm - Current search term
 * @param {Function} props.setSearchTerm - Callback to update search term
 * @param {Function} props.onNewAssignment - Callback to open create modal
 * @param {Function} props.onSwitchToCalendar - Callback to switch to calendar view
 * @param {Function} props.onExport - Callback to trigger PDF export
 * @param {boolean} props.isReadOnly - Whether the view is read-only
 */
export default function ListViewHeader({
    searchTerm,
    setSearchTerm,
    onNewAssignment,
    onSwitchToCalendar,
    onExport,
    isReadOnly
}) {
    return (
        <div className="leader-list-header">
            <div className="leader-list-header-left">
                <h2>Einsatzliste</h2>
            </div>
            <div className="leader-list-header-actions">
                <div className="leader-list-header-search" style={{ width: '250px' }}>
                    <SharedSearchInput 
                        placeholder="Suchen..." 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onClear={() => setSearchTerm('')}
                    />
                </div>
                 {!isReadOnly && (
                    <button className="btn-new-assignment" onClick={onNewAssignment}>
                        + Neuer Einsatz
                    </button>
                )}
                <button
                    className="view-toggle-btn"
                    onClick={onSwitchToCalendar}
                >
                    📅 Kalender
                </button>
                {onExport && (
                    <button 
                        className="view-toggle-btn" 
                        onClick={() => onExport()}
                        style={{ marginLeft: '4px' }}
                    >
                        📄 PDF
                    </button>
                )}
            </div>
        </div>
    );
}
